import dayjs from "dayjs";

export type LeaderboardDateRangeType =
	| "lastWeek"
	| "lastMonth"
	| "lastYear"
	| "customDateRange";

export interface LeaderboardDateFilterState {
	dateRangeType: LeaderboardDateRangeType;
	dateFrom: string;
	dateTo: string;
}

function getDateRange(type: LeaderboardDateRangeType): {dateFrom: string; dateTo: string} {
	switch (type) {
		case "lastWeek":
			return {
				dateFrom: dayjs().startOf("week").format("YYYY-MM-DD"),
				dateTo: dayjs().startOf("day").format("YYYY-MM-DD")
			};
		case "lastMonth":
			return {
				dateFrom: dayjs().startOf("month").format("YYYY-MM-DD"),
				dateTo: dayjs().startOf("day").format("YYYY-MM-DD")
			};
		case "lastYear":
			return {
				dateFrom: dayjs().startOf("year").format("YYYY-MM-DD"),
				dateTo: dayjs().startOf("day").format("YYYY-MM-DD")
			};
		case "customDateRange":
			return {
				dateFrom: dayjs().startOf("week").format("YYYY-MM-DD"),
				dateTo: dayjs().startOf("day").format("YYYY-MM-DD")
			};
	}
}

export function createDefaultLeaderboardDateFilters(): LeaderboardDateFilterState {
	const dateRangeType: LeaderboardDateRangeType = "lastMonth";
	const {dateFrom, dateTo} = getDateRange(dateRangeType);
	return {dateRangeType, dateFrom, dateTo};
}

export function applyLeaderboardDateFilterUpdate(
	prev: LeaderboardDateFilterState,
	updates: Partial<LeaderboardDateFilterState>
): LeaderboardDateFilterState {
	const next = {...prev, ...updates};

	if (updates.dateRangeType && updates.dateRangeType !== "customDateRange") {
		const range = getDateRange(updates.dateRangeType);
		next.dateFrom = range.dateFrom;
		next.dateTo = range.dateTo;
	}

	return next;
}
